/* =====================================================
   SOFS — Explorador de fotos en la tarjeta de producto
   Flechas a los lados (solo desktop) para ver las primeras 4 fotos.

   Cómo se reparte el trabajo con el tema:
   - Sin foto elegida (pos 0) esta capa es transparente: manda el tema, que
     muestra la foto 1 en reposo y hace el barrido al pasar el mouse.
   - Al usar las flechas la capa se pone encima con la foto pedida. La primera
     flecha arranca desde la foto que dejó el barrido (la manda el Liquid en
     data-sofs-cg-hover-pos, normalmente la 2).
   - Al salir de la tarjeta se suelta la capa y vuelve la foto 1.

   Dos cosas que hay que respetar o se ve un parpadeo:
   1. La foto nueva se pinta SOLO cuando terminó de bajar. Mientras baja se
      queda la que está: nunca un hueco en blanco.
   2. La foto 1 de esta capa reusa el srcset que ya cargó el tema, así el
      navegador la saca del caché en vez de bajarla otra vez.

   Ojo: el archivo puede quedar cargado dos veces (tema + inyección por AJAX
   de la compra rápida), por eso la bandera de arriba.
   ===================================================== */
(function () {
  if (window.__sofsCardGalleryReady) return;
  window.__sofsCardGalleryReady = true;

  var DESKTOP = '(min-width: 1024px) and (hover: hover)';
  var mq = window.matchMedia(DESKTOP);

  function closest(node, sel) {
    if (!node || !node.closest) return null;
    return node.closest(sel);
  }

  function slidesOf(gallery) {
    return gallery.querySelectorAll('[data-sofs-cg-slide]');
  }

  function hydrateSlide(gallery, slide) {
    var img = slide.querySelector('img[data-src]');
    if (!img) return;

    // La foto 1 ya está en pantalla (la dibuja el tema): copiarle el srcset
    // para que salga del caché y no cueste una descarga nueva.
    if (slide.hasAttribute('data-sofs-cg-featured')) {
      var card = closest(gallery, '[data-product-block]');
      var themeImg = card && card.querySelector('[data-main-image] img, [data-product-image] img');
      var themeSrc = themeImg && (themeImg.currentSrc || themeImg.getAttribute('src'));
      if (themeSrc) {
        var ss = themeImg.getAttribute('srcset');
        var sz = themeImg.getAttribute('sizes');
        if (ss) img.setAttribute('srcset', ss);
        if (sz) img.setAttribute('sizes', sz);
        img.setAttribute('src', themeSrc);
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
        return;
      }
    }

    var srcset = img.getAttribute('data-srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    img.setAttribute('src', img.getAttribute('data-src'));
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  }

  function hydrateCard(gallery) {
    if (gallery.getAttribute('data-sofs-cg-ready')) return;
    gallery.setAttribute('data-sofs-cg-ready', '1');
    var slides = slidesOf(gallery);
    for (var i = 0; i < slides.length; i++) hydrateSlide(gallery, slides[i]);
  }

  function paint(slides, pos) {
    for (var i = 0; i < slides.length; i++) {
      if (pos !== 0 && i === pos - 1) slides[i].classList.add('is-active');
      else slides[i].classList.remove('is-active');
    }
  }

  // pos: 0 = sin foto elegida (manda el tema) · 1..N = foto N
  function show(gallery, pos) {
    var slides = slidesOf(gallery);
    var total = slides.length;
    if (!total) return;
    if (pos !== 0) pos = ((((pos - 1) % total) + total) % total) + 1;
    gallery.setAttribute('data-sofs-cg-pos', pos);

    if (pos === 0) {
      paint(slides, 0);
      return;
    }

    var slide = slides[pos - 1];
    hydrateSlide(gallery, slide);
    var img = slide.querySelector('img');

    // Si la foto todavía está bajando, dejar la actual hasta que esté lista.
    if (img && !img.complete) {
      img.addEventListener(
        'load',
        function () {
          if (parseInt(gallery.getAttribute('data-sofs-cg-pos') || '0', 10) === pos) {
            paint(slidesOf(gallery), pos);
          }
        },
        { once: true }
      );
      return;
    }

    paint(slides, pos);
  }

  function galleryInCard(card) {
    return card ? card.querySelector('[data-sofs-card-gallery]') : null;
  }

  document.addEventListener(
    'pointerover',
    function (e) {
      if (!mq.matches) return;
      var gallery = galleryInCard(closest(e.target, '[data-product-block]'));
      if (gallery) hydrateCard(gallery);
    },
    true
  );

  // Salir de la tarjeta: soltar la capa y volver a la foto 1.
  document.addEventListener(
    'pointerout',
    function (e) {
      if (!mq.matches) return;
      var card = closest(e.target, '[data-product-block]');
      if (!card) return;
      if (e.relatedTarget && card.contains(e.relatedTarget)) return; // sigue dentro
      var gallery = galleryInCard(card);
      if (gallery) show(gallery, 0);
    },
    true
  );

  // Red de seguridad: si la tarjeta dejó de estar bajo el mouse sin que llegara
  // el pointerout (pasa al hacer scroll sin mover el mouse), soltar la capa.
  window.addEventListener(
    'scroll',
    function () {
      if (!mq.matches) return;
      var abiertas = document.querySelectorAll('[data-sofs-card-gallery][data-sofs-cg-pos]:not([data-sofs-cg-pos="0"])');
      for (var i = 0; i < abiertas.length; i++) {
        var card = closest(abiertas[i], '[data-product-block]');
        if (card && !card.matches(':hover')) show(abiertas[i], 0);
      }
    },
    { passive: true }
  );

  // Flechas. En captura para que nunca dispare el enlace de la tarjeta.
  document.addEventListener(
    'click',
    function (e) {
      var btn = closest(e.target, '[data-sofs-cg-prev], [data-sofs-cg-next]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var gallery = closest(btn, '[data-sofs-card-gallery]');
      if (!gallery) return;
      hydrateCard(gallery);
      var pos = parseInt(gallery.getAttribute('data-sofs-cg-pos') || '0', 10) || 0;
      if (pos === 0) {
        // Veníamos del barrido del tema: seguir desde la foto que dejó.
        pos = parseInt(gallery.getAttribute('data-sofs-cg-hover-pos') || '2', 10) || 2;
      }
      show(gallery, btn.hasAttribute('data-sofs-cg-next') ? pos + 1 : pos - 1);
    },
    true
  );
})();
